import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import CardContent from "@origyn-sa/common-ui/src/components/atoms/CardContent";
import { H2, H3 } from "@origyn-sa/common-ui/src/components/atoms/H/H.styled";
import Form from "@origyn-sa/common-ui/src/components/templates/Form";
import InputField from "@origyn-sa/common-ui/src/components/molecules/InputField";
import Button from "@origyn-sa/common-ui/src/components/atoms/Button";
import HR from "@origyn-sa/common-ui/src/components/atoms/HR/HR.styled";
import { ProductCardInput } from "../../utils";

export interface IApprovalItemModal {
  open: boolean;
  onClose?: () => void;
  item: ProductCardInput;
  onApprove: (val: any) => void;
  onRemoveApproval: (val: any) => void;
  approvals: Array<{ _principal: string }>;
}

const ApprovalItemModal = ({
  open,
  onClose,
  item,
  onApprove,
  onRemoveApproval,
}: IApprovalItemModal) => {
  const [spender, setSpender] = useState("");
  const [approvedSpender, setApprovedSpender] = useState("");

  const onSubmit = (data: any) => {
    console.log("onSubmit", data);
    if (onApprove)
      onApprove({
        spender,
      });
  };

  const onSubmitRemove = (data: any) => {
    console.log("onSubmitRemove", data);
    if (onRemoveApproval)
      onRemoveApproval({
        approvedSpender,
      });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <CardContent textAlign='center' padding='40px 55px'>
        <Grid container justify='center' spacing={1}>
          <Grid item>
            <H3 spacing={[0, 3]}>Approvals</H3>
          </Grid>
        </Grid>
        <br />

        <Form onSubmit={onSubmit}>
          <Grid item xs={12}>
            <InputField
              disabled
              label='Token ID'
              defaultValue={item.id}
              name='principal'
              placeholder='Principal'
            />
            <InputField
              required
              label='Approved Spender Principal'
              name='principal'
              defaultValue={spender}
              onChange={(e: any) => {
                setSpender(e.target.value);
              }}
              placeholder='Principal'
            />
          </Grid>
          <Button type='submit' spacing={2}>
            Add approved spender
          </Button>
        </Form>

        <HR />

        <Form onSubmit={onSubmitRemove}>
          <Grid item xs={12}>
            <InputField
              disabled
              label='Token ID'
              defaultValue={item.id}
              name='principal'
              placeholder='Principal'
            />
            <InputField
              required
              label='Existing Approved Spender Principal'
              name='principal'
              placeholder='Principal'
              defaultValue={approvedSpender}
              onChange={(val: any) => {
                setApprovedSpender(val.target.value);
              }}
            />
          </Grid>
          <Button color='warning' type='submit' spacing={2}>
            Remove approved spender
          </Button>
        </Form>
      </CardContent>
    </Dialog>
  );
};

export default ApprovalItemModal;
